var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5536",
    "data-name": "Group 5536",
    transform: "translate(-1192.5 -245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1960",
    "data-name": "Rectangle 1960",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(1192.5 245)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar_1_",
    "data-name": "calendar (1)",
    transform: "translate(1206.5 229.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3345",
    "data-name": "Path 3345",
    d: "M.644,161.3H17.488a.645.645,0,0,0,.413-.149c.162-.135,3.852-3.31,4.077-10.164H3.888c-.224,6.221-3.623,9.145-3.658,9.174A.645.645,0,0,0,.644,161.3Z",
    transform: "translate(0 -114.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    "data-name": "Path 3346",
    d: "M108.422,32.277H105.2v-.645a.645.645,0,0,0-1.289,0v.645h-3.266v-.645a.645.645,0,0,0-1.289,0v.645H96.132v-.645a.645.645,0,0,0-1.289,0v.645H91.621a.638.638,0,0,0-.645.645v1.934h18.091V32.922A.638.638,0,0,0,108.422,32.277Z",
    transform: "translate(-87.067 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3347",
    "data-name": "Path 3347",
    d: "M105.8,302.685a1.94,1.94,0,0,1-1.241.45H90.977v1.934a.644.644,0,0,0,.645.645h16.8a.644.644,0,0,0,.645-.645v-7.225A12.774,12.774,0,0,1,105.8,302.685Z",
    transform: "translate(-87.068 -255.388)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiBooking);
export default __webpack_public_path__ + "static/media/multiBooking.4c17f5ec7e485953667b41f840efd701.svg";
export { ForwardRef as ReactComponent };